import { defineMessages } from 'react-intl';

export default defineMessages({
  contribution: {
    id: 'ReactFilters.messages.provenance.contribution',
    defaultMessage: 'Contribution',
  },
  aggregation: {
    id: 'ReactFilters.messages.provenance.aggregation',
    defaultMessage: 'Aggregation',
  },
  share: {
    id: 'ReactFilters.messages.provenance.share',
    defaultMessage: 'Share',
  },
});
